module.exports = __webpack_public_path__ + "img/authentication-bg.1c65d14a.png";